import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
const SUCCESE = async (data: any) => {
  toast.success(data, {
    position: toast.POSITION.TOP_LEFT,
  });
};
const FAILED = async (data: any) => {
  console.log(data);
  toast.error(data.message, {
    position: toast.POSITION.TOP_LEFT,
  });
};

export const EditBusinessBhannel = createSlice({
  name: "EditBusinessBhannel",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    data: [],
  },
  reducers: {
    edit_business_channel: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_edit_business_channel: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      // SUCCESE(action.payload.message);
    },
    failure_api_call_edit_business_channel: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.api_completed = true;
      // FAILED(action.payload);
    },
    edit_business_channel_isSuccess: (state, action) => {
      state.isSuccess = false;
    },
    edit_business_channel_api_complete: (state, action) => {
      state.api_completed = false;
    },
  },
});
export default EditBusinessBhannel.reducer;
export const {
  edit_business_channel,
  success_api_call_edit_business_channel,
  edit_business_channel_isSuccess,
  edit_business_channel_api_complete,
  failure_api_call_edit_business_channel,
} = EditBusinessBhannel.actions;
